import React from "react";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { OpenRightPanel } from "types/common/rightPanel";
import {
  PaymentPolicyLinkButton,
  PaymentPolicyLinksContainer,
  PaymentPolicyLinksList,
} from "./PaymentButton.styles";

export type PaymentPolicyHelpPanelContext = {
  openRightPanel: OpenRightPanel;
  returnPanelType: string;
  getReturnPanelData?: () => any;
};

const HELP_ARTICLES = [
  {
    translationKey: "purchase.creditCard.articles.refundPolicy",
    showHelpersCode: "refund",
  },
  {
    translationKey: "purchase.creditCard.articles.privacyPolicy",
    showHelpersCode: "privacy",
  },
  {
    translationKey: "purchase.creditCard.articles.termsOfService",
    showHelpersCode: "terms",
  },
  {
    translationKey: "purchase.creditCard.articles.cancellations",
    showHelpersCode: "cancellations",
  },
  {
    translationKey: "purchase.creditCard.articles.contact",
    showHelpersCode: "contact",
  },
] as const;

interface PaymentPolicyLinksProps {
  helpPanelContext?: PaymentPolicyHelpPanelContext;
}

const PaymentPolicyLinks: React.FC<PaymentPolicyLinksProps> = React.memo(
  ({ helpPanelContext }) => {
    const { t } = useTranslation("common");

    const openHelpArticle = React.useCallback(
      (title: string, showHelpersCode: string) => {
        if (!helpPanelContext) {
          return;
        }

        let helpPanelData = Map({
          preventReLoading: true,
          headerTitle: title,
          showHelpersCode,
          returnPanelType: helpPanelContext.returnPanelType,
        });

        const returnPanelData = helpPanelContext.getReturnPanelData?.();

        if (returnPanelData !== undefined) {
          helpPanelData = helpPanelData.set("returnPanelData", returnPanelData);
        }

        helpPanelContext.openRightPanel("HELP_PANEL", helpPanelData);
      },
      [helpPanelContext],
    );

    if (!helpPanelContext) {
      return null;
    }

    return (
      <PaymentPolicyLinksContainer>
        <PaymentPolicyLinksList>
          {HELP_ARTICLES.map(({ translationKey, showHelpersCode }) => {
            const title = t(translationKey);

            return (
              <PaymentPolicyLinkButton
                key={showHelpersCode}
                type="button"
                onClick={() => openHelpArticle(title, showHelpersCode)}
              >
                {title}
              </PaymentPolicyLinkButton>
            );
          })}
        </PaymentPolicyLinksList>
      </PaymentPolicyLinksContainer>
    );
  },
);

export default PaymentPolicyLinks;
